import React, { useEffect, useState } from "react";
import { Loader2, Briefcase, Sun, CalendarRange, CalendarClock } from "lucide-react";
import empApi from "../../lib/empApi";

const SECTIONS = [
  { key: "responsibilities", label: "Tanggung Jawab", icon: Briefcase, color: "text-amber-300" },
  { key: "daily_tasks", label: "Tugas Harian", icon: Sun, color: "text-emerald-300" },
  { key: "weekly_tasks", label: "Tugas Mingguan", icon: CalendarRange, color: "text-sky-300" },
  { key: "monthly_tasks", label: "Tugas Bulanan", icon: CalendarClock, color: "text-fuchsia-300" },
];

export default function EmpJobdesk() {
  const [jd, setJd] = useState(null);
  useEffect(() => { empApi.get("/employee/jobdesk").then(({ data }) => setJd(data)).catch(() => {}); }, []);
  if (!jd) return <div className="flex h-64 items-center justify-center"><Loader2 className="animate-spin text-amber-400" /></div>;

  return (
    <div className="space-y-4" data-testid="emp-jobdesk-page">
      <div className="flex items-center gap-2"><Briefcase size={20} className="text-amber-400" /><h2 className="font-heading text-xl font-bold text-white">Jobdesk Saya</h2></div>
      <p className="text-sm text-slate-400">Posisi: <span className="font-semibold text-white">{jd.position}</span></p>

      {SECTIONS.map(({ key, label, icon: Icon, color }) => (
        <div key={key} className="rounded-2xl border border-slate-800 bg-slate-800/40 p-4" data-testid={`emp-jobdesk-${key}`}>
          <p className={`mb-2 flex items-center gap-2 text-sm font-semibold ${color}`}><Icon size={16} /> {label}</p>
          {(jd[key] || []).length === 0 ? <p className="text-xs text-slate-500">—</p> : (
            <ul className="space-y-1.5">
              {jd[key].map((t, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-slate-300"><span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-amber-400" /> {t}</li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}
